module.exports = __webpack_public_path__ + "img/exit2x.png?d6d33d80e60123737449f36b081c7507";